module.exports = __webpack_public_path__ + "static/img/logo.8622b9ca.png";